import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlanClass.Delete.IRequest;
type Response = Api.Core.ProductPricingPlanClass.Delete.IResponse;
type Headers = Api.Core.ProductPricingPlanClass.Delete.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlanClass/:id';
export default async function productPricingPlanClassDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
